<script setup lang="ts">
import {CourseItem} from "@/types";
import {getCourseStatus} from "@/utils/common.ts";
import {useRouter} from "vue-router";

const router = useRouter()
const props = defineProps<{
  item: CourseItem
}>()

const detail = () => {
  const routeData =router.resolve({
    name: "CourseDetail",
    params: {
      id: props.item.id
    }
  })
  window.open(routeData.href, "_blank");
}

const emit = defineEmits(["delete"])

const del = () => {
  emit("delete", props.item.id)
}

defineExpose({detail, del})
</script>

<template>
  <div class="mt-2rem">
    <div class="flex items-start">
      <div class="relative w-15rem h-8.4375rem mr-1.5rem">
        <el-image :src="item.thumb_image" style="width: 15rem; height: 8.4375rem"/>
        <el-tag type="info" effect="dark" v-if="item.is_secret === 2" class="absolute top-0 left-0">联培课 </el-tag>
        <el-tag type="info" effect="dark" v-if="item.is_secret === 1" class="absolute top-0 left-0">私密课 </el-tag>
        <el-tag type="primary" effect="light" v-if="item.is_fake === 1" class="absolute top-0 right-0">AI直播</el-tag>
      </div>
      <div class="mr-7rem flex-1">
        <div class="flex items-center gap-.75rem">
          <el-tag
              :type="item.status === 1 ? `primary` : item.status === 0 ? `info` : item.status === 2? `primary` : `primary`"
              round
              :effect="item.status === 1 || item.status === 0 ? `dark` : `light`">
            {{ getCourseStatus(item.status) }}
          </el-tag>
          <div class="text-1em text-#161616">
            {{ item.title }}
          </div>
        </div>
        <div class="text-.875em text-#939393 mt-.75rem">
          {{ item.short_detail }}
        </div>
        <div class="text-.75em text-#939393 mt-.75rem">
          <template v-if="item.type === 1 || item.type === 2">
            共 {{ item.total_section }} 讲
          </template>
          <template v-if="item.type === 1">
            ，每讲 {{ item.duration }} 分钟
          </template>
          <template v-if="item.type === 3 || item.type === 4">
            共 {{ item.total_section }} 门课
          </template>
          <template v-if="(item.type === 3 || item.type === 4) && item.course_title.length > 0">
            , {{ item.course_title.map((item) => item.title).join('，') }}
          </template>
        </div>
        <div class="flex items-center mt-1.5rem" v-if="item.status === 1">
          <div class="mr-2rem">
            <img src="@/assets/image/icon/icon-view.png" class="w-.875rem h-.875rem mr-.5rem"  alt="icon-view"/>
            <span class="text-#00000040 text-.75em">{{ item.view_num }}</span>
          </div>
          <div class="mr-2rem">
            <img src="@/assets/image/icon/icon-apply.png" class="w-.875rem h-.875rem mr-.5rem"  alt="icon-apply"/>
            <span class="text-#00000040 text-.75em">{{ item.apply_size }}</span>
          </div>
          <div class="mr-2rem">
            <img src="@/assets/image/icon/icon-comment.png" class="w-.875rem h-.875rem mr-.5rem"  alt="icon-comment"/>
            <span class="text-#00000040 text-.75em">{{ item.comment_num }}</span>
          </div>
          <div class="mr-2rem">
            <img src="@/assets/image/icon/icon-collect.png" class="w-.875rem h-.875rem mr-.5rem"  alt="icon-collect"/>
            <span class="text-#00000040 text-.75em">{{ item.collect_num }}</span>
          </div>
          <div class="mr-2rem">
            <img src="@/assets/image/icon/icon-share.png" class="w-.875rem h-.875rem mr-.5rem"  alt="icon-share"/>
            <span class="text-#00000040 text-.75em">{{ item.share_num }}</span>
          </div>
        </div>
      </div>
      <div class="flex items-center m-auto">
        <el-button type="primary" plain @click="detail">详情</el-button>
        <el-button type="danger" plain @click="del" v-if="item.status !== 1">删除</el-button>
      </div>
    </div>
    <div class="bg-#f5f5f5 h-2px mt-2rem"></div>
  </div>
</template>

<style scoped>
</style>
